import { useDispatch } from 'react-redux'
import { setSnackbar } from '../../components/GenericSnackbar/generic-snackbar-slice'
import Constants from '../../constants/en.json'

export function useHandleCopyContent() {
  const dispatch = useDispatch()
  function handleCopyContent(content) {
    navigator.clipboard
      .writeText(content)
      .then(() => {
        dispatch(
          setSnackbar({
            message: `${Constants.orders.order_details.CONTACT_EMAIL_MESSAGE}`,
            severity: 'success',
            action: true,
          }),
        )
      })
      .catch(() => {
        dispatch(
          setSnackbar({
            message: `${Constants.orders.order_details.CONTACT_EMAIL_MESSAGE}`,
            severity: 'error',
            action: true,
          }),
        )
      })
  }

  return {
    handleCopyContent,
  }
}
